import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const reducer = createReducer([], (builder) => {
  builder
    .addCase(actionTypes.EDIT_RECURRING_TASK_SUCCESS, (state, action) => {
      const { attributes = {}, taskId = 0 } = action;
      const toUpdate = state.filter((task) => task?.created_from_recurring_task_id === taskId);

      if (toUpdate.length > 0) {
        state = state.filter((task) => task?.created_from_recurring_task_id !== taskId);
        toUpdate.forEach((task) => {
          state = [
            ...state,
            {
              ...task,
              ...attributes,
            },
          ];
        });
      }

      return state;
    })
    .addCase(actionTypes.FETCH_CALENDAR_ASSIGMENTS_SUCCESS, (state, action) => {
      const { response = {} } = action;
      const { result = {} } = response;
      const { recurring_tasks = [] } = result;

      return recurring_tasks;
    })
    .addCase(actionTypes.FETCH_GHOST_TASKS_SUCCESS, (state, action) => {
      const { response = {} } = action;
      const { recurring_tasks = [] } = response;

      return recurring_tasks;
    });
});

export default reducer;
